// Might be undefined if referenced by other layouts like login
const Motohelp = window.Motohelp || {};

// Algolia configuration
export default {
    BIKE_INDEX: 'Bike',
    CITY_INDEX: 'Italy_City',
    APPLICATION_ID: Motohelp.search_application_id,
    SEARCH_API_KEY: Motohelp.search_api_key
}
